
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-qty-button]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(btn.dataset.qtyButton || 0);
      const min = Number(input.min || 0);
      input.value = Math.max(min, Number(input.value || 0) + step);
      const form = btn.closest('form');
      if (form && btn.closest('[data-cart-line]')) form.requestSubmit();
    });
  });
  document.querySelectorAll('[data-variant-select]').forEach(select => {
    const root = select.closest('[data-product-root]');
    if (!root) return;
    const price = root.querySelector('[data-product-price]');
    const add = root.querySelector('[data-add-to-cart]');
    const sync = () => {
      const opt = select.options[select.selectedIndex];
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      if (add) {
        const available = opt.dataset.available === 'true';
        add.disabled = !available;
        add.textContent = available ? add.dataset.availableText : add.dataset.soldoutText;
      }
    };
    select.addEventListener('change', sync); sync();
  });
});

/* Quick add picker: product cards with more than one variant open a variant list before adding to the cart. */
(() => {
  let modal = null;
  let state = null;

  function build() {
    const dialog = document.createElement('dialog');
    dialog.className = 'qa-modal';
    dialog.innerHTML =
      '<div class="qa-panel">' +
        '<button class="qa-close" type="button" data-qa-close aria-label="Close">&times;</button>' +
        '<div class="qa-head">' +
          '<img class="qa-image" alt="" hidden>' +
          '<div><div class="qa-eyebrow" data-qa-eyebrow></div><h3 class="qa-title" data-qa-title></h3></div>' +
        '</div>' +
        '<div class="qa-options" role="radiogroup" data-qa-options></div>' +
        '<div class="qa-foot">' +
          '<div class="qa-price" data-qa-price></div>' +
          '<button class="btn qa-add" type="button" data-qa-add disabled></button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dialog);
    dialog.addEventListener('click', event => {
      if (event.target === dialog || event.target.closest('[data-qa-close]')) dialog.close();
    });
    dialog.querySelector('[data-qa-add]').addEventListener('click', () => {
      if (!state || !state.selected) return;
      state.idInput.value = state.selected.id;
      dialog.close();
      state.form.requestSubmit();
    });
    dialog.querySelector('[data-qa-options]').addEventListener('change', event => {
      const input = event.target.closest('input[type="radio"]');
      if (!input || !state) return;
      state.selected = state.variants.find(variant => String(variant.id) === input.value) || null;
      renderPrice();
    });
    return dialog;
  }

  function renderImage() {
    const image = modal.querySelector('.qa-image');
    const src = (state.selected && state.selected.image) || state.image;
    image.hidden = !src;
    if (src && image.getAttribute('src') !== src) image.src = src;
  }

  function renderPrice() {
    renderImage();
    const price = modal.querySelector('[data-qa-price]');
    const add = modal.querySelector('[data-qa-add]');
    if (!state.selected) {
      price.textContent = '';
      add.disabled = true;
      add.textContent = state.texts.add;
      return;
    }
    price.innerHTML = '';
    const current = document.createElement('strong');
    current.textContent = state.selected.price;
    price.appendChild(current);
    if (state.selected.compare) {
      const compare = document.createElement('s');
      compare.textContent = state.selected.compare;
      price.appendChild(compare);
    }
    add.disabled = !state.selected.available;
    add.textContent = state.selected.available ? state.texts.add : state.texts.soldout;
  }

  function open(button) {
    const form = button.closest('form');
    const dataNode = form && form.querySelector('[data-quick-add-variants]');
    if (!form || !dataNode) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }
    modal = modal || build();
    state = {
      form,
      idInput: form.querySelector('input[name="id"]'),
      variants: data.variants || [],
      image: data.image || null,
      selected: null,
      texts: {
        add: button.dataset.addText || 'Add to cart',
        soldout: button.dataset.soldoutText || 'Sold out',
        choose: button.dataset.chooseText || 'Choose an option',
        close: button.dataset.closeText || 'Close'
      }
    };

    modal.querySelector('[data-qa-eyebrow]').textContent = state.texts.choose;
    modal.querySelector('[data-qa-close]').setAttribute('aria-label', state.texts.close);
    const title = modal.querySelector('[data-qa-title]');
    title.innerHTML = '';
    const link = document.createElement('a');
    link.href = data.url || '#';
    link.textContent = data.title || '';
    title.appendChild(link);

    const options = modal.querySelector('[data-qa-options]');
    options.innerHTML = '';
    state.variants.forEach((variant, index) => {
      const label = document.createElement('label');
      label.className = 'qa-option' + (variant.available ? '' : ' is-soldout');
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'qa-variant';
      input.value = String(variant.id);
      input.disabled = !variant.available;
      input.id = 'qa-variant-' + index;
      const name = document.createElement('span');
      name.className = 'qa-option-title';
      name.textContent = variant.title;
      const price = document.createElement('span');
      price.className = 'qa-option-price';
      if (variant.available) {
        price.textContent = variant.price;
        if (variant.compare) {
          const compare = document.createElement('s');
          compare.textContent = variant.compare;
          price.appendChild(document.createTextNode(' '));
          price.appendChild(compare);
        }
      } else {
        price.textContent = state.texts.soldout;
      }
      label.append(input, name, price);
      options.appendChild(label);
    });

    renderPrice();
    modal.showModal();
    const first = options.querySelector('input:not(:disabled)');
    if (first) first.focus();
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quick-add-picker]');
    if (!button || button.disabled) return;
    event.preventDefault();
    open(button);
  });
})();
